import React from 'react';

import {labels} from '../../../../util/utils';

import StyledRollForwardButton from './StyledRollForwardButton';
import Button from '../../../CoreWrappers/Button';

const RollForwardButton = ({...rest}) => {
	const props = {
		...rest,
		label: labels.rollForward
	};

	return (
		<StyledRollForwardButton>
			<Button {...props} />
		</StyledRollForwardButton>
	);
};

export default RollForwardButton;
